import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { Incident } from '@/modules/reports/shared/domain/incident';

class IncidentsRepository extends HttpRepository {
    private static readonly RESOURCE = 'incidents';

    createIncident(incident: Incident) {
        return this.post(
            this.createUri([`${IncidentsRepository.RESOURCE}`]),
            incident,
            this.createAuthorizationHeader(),
        );
    }

    async listIncidents(options: { limit: number; start: number }) {
        return this.get(
            this.createUri([
                `${IncidentsRepository.RESOURCE}?limit=${options.limit}&start=${options.start}`,
            ]),
            this.createAuthorizationHeader(),
        );
    }

    async getIncidentsReport(data: { dataCenter: number; year: string; summary: number }) {
        const s = data.summary ? '&summary=1' : '';
        return this.get(
            this.createUri([
                `${IncidentsRepository.RESOURCE}/incident-report?dataCenterId=${data.dataCenter}&year=${data.year}${s}`,
            ]),
            this.createAuthorizationDocumentsHeader(),
        );
    }
}

export default new IncidentsRepository();
